import { useTranslation } from 'react-i18next';

import { SignInPageController } from 'pages/SignIn/machine';
import { STORAGE_KEY_PASSKEY_LOGIN } from 'utils/constants';

export function PasskeyLoginLink(): JSX.Element | null {
  const [t] = useTranslation();
  const actor = SignInPageController.useActorRef();

  if (
    !CONFIG.shouldDisplayPasskeySignInLink &&
    localStorage.getItem(STORAGE_KEY_PASSKEY_LOGIN) === null
  ) {
    return null;
  }

  return (
    /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
    <a
      data-test-id="passkey-login-link"
      href="#"
      onClick={(event) => {
        event.preventDefault();
        actor.send({ type: 'Log in with Passkey' });
      }}
    >
      {t('forms.passkey_login')}
    </a>
  );
}
